import { render, staticRenderFns } from "./AreaLegend.vue?vue&type=template&id=456f21d6&"
import script from "./AreaLegend.vue?vue&type=script&lang=ts&"
export * from "./AreaLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports